export default "__VITE_ASSET__Ebaht2ls__"